// TODO: Once all consumers are on react-transition-group v2, delete this file
// and CSSTransitionGroupCompat.v1.tsx, then import from react-transition-group
// directly using CSSTransition + TransitionGroup (see .v2.tsx for the mapping).
// Also remove the `&.white-veil-leave` selector from FadingVeil.tsx and change
// runtimeDeps to "2" in static_conf.json.
/* eslint-disable @typescript-eslint/no-var-requires */
const CSSTransitionGroup = $hasDep('react-transition-group', '2') ? require('./CSSTransitionGroupCompat.v2').CSSTransitionGroup : require('./CSSTransitionGroupCompat.v1').CSSTransitionGroup;
export { CSSTransitionGroup };